import {Injectable} from '@angular/core';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
// Router ??
import {Router} from "@angular/router";
import * as firebase from 'firebase/app';

@Injectable()
export class AutorizacionService{
    constructor(private angularFireAuth: AngularFireAuth, private router:Router){
        // al momento de comenzar la app
        this.isLogged();
    }

    // 
    public facebookLogin(){
        this.angularFireAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider())
            .then((result)=>{
                alert('usuario logueado con Facebook T2');
                console.log(result);
                this.router.navigate(['lugares']);
            })
            .catch((error)=>{
                console.log('error'+ error);
            });
    }

    public login = (email, password)=>{
        console.log('Método de LOGIN >>> Service'+email+' , '+password)
        this.angularFireAuth.auth.signInWithEmailAndPassword(email, password)
            .then((response)=>{
              alert('usuario Logueado');
              this.router.navigate(['lugares']);
              console.log(response);
            }).catch((error)=>{
                console.log(error);
                alert("ha ocurrido un error");
                // SweetAlert 2
                
            })
    }
    public registro = (email, password)=>{
        console.log('Método de regisotr Service')
        this.angularFireAuth.auth.createUserWithEmailAndPassword(email, password)
            .then((response)=>{
              alert('usuario registrado');
              console.log(response);
            }).catch((error)=>{
                console.log(error);
                alert("ha ocurrido un error");
                // SweetAlert 2

            })
    }

    /* Nueva funcio , nos vamos a suscribir a el, mnonitoreando que el ususario esté logueado */
    public isLogged(){
        return this.angularFireAuth.authState;
    }

    // Obtener el email
    public getEmailUser(){
        return this.getUserData().currentUser.email;
    }
    public getUrlPhoto(){
        return this.getUserData().currentUser.photoURL;
    }

    // Obtener la data general del Usuario a nivel LOCAL, no público
    private getUserData(){
        return this.angularFireAuth.auth;
    }

    // LogOut
    public logOut(){
        this.angularFireAuth.auth.signOut();
        // redireccionar
        this.router.navigate(['home']);
        location.reload();
    }
}


// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/services/autorizacion.service.ts